// src/locales/vi-custom.js
import { vi as originalVi } from 'date-fns/locale'

const customVi = {
  ...originalVi,
  localize: {
    ...originalVi.localize,
    day: (n) => {
      // n: 0=CN, 1=T2, ..., 6=T7
      const dayNames = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']
      return dayNames[n]
    },
    month: (n, options) => {
      if (options && options.width === 'abbreviated') {
        // Hiển thị "tháng 1", "tháng 2", ...
        return `tháng ${n + 1}`
      }
      // Trường hợp khác thì giữ nguyên của locale gốc
      return originalVi.localize.month(n, options)
    }
  }
}

export default customVi